import React from 'react';

export default function UserDashboardHeader({ user, car }) {
    return (
        <div className="flex justify-content-between align-items-center mb-4 p-3 border-round-xl shadow-1 bg-white">
            <div>
                <h1 className="text-2xl font-bold m-0" style={{ color: '#21588C' }}>
                    ¡Hola, {user?.name?.split(' ')[0]}! 👋
                </h1>
                <p className="text-gray-600 m-0">Bienvenido a tu dashboard personal de Peicar</p>
            </div>
            <div className="text-right hidden md:block">
                <span className="text-sm font-semibold text-gray-500 block">TU VEHÍCULO</span>
                <span className="text-lg font-bold" style={{ color: '#32b8df' }}>
                    {car?.brand} {car?.model} {car?.year}
                </span>
            </div>
        </div>
    );
}
